export function selectCorrectRanks(question: any) {
  return question.data.answers.filter((it: any) => it.correctRank != null).map((it: any) => [it.id, it.correctRank]);
}
